import * as React from 'react';

import {convertLineToBar} from '../../util/plotHelpers/lines';
import {BarChart as VisBarChart} from '../vis/BarChart/BarChart';
import {type RenderLine} from '../vis/chartSeries';
import {isValidLine} from './utils/checkTypes';

export const BarChart = React.memo(
  (props: {lines: RenderLine[]; min?: number | null; max?: number | null}) => {
    const {lines, min, max} = props;
    const filteredLines = lines.filter(isValidLine);
    const bars = filteredLines.map(line =>
      convertLineToBar({
        ...line,
        name: line.highlightName ?? undefined,
        uniqueId: line.highlightId ?? undefined,
      })
    );

    return (
      <VisBarChart
        bars={bars}
        min={min ?? undefined}
        max={max ?? undefined}
        showAllLabels
      />
    );
  }
);

BarChart.displayName = 'BarChart';
